import http from "@/shared/services/http";
import {FreightServiceAddParams} from "@/modules/freightserviceadds/params";

export const createFreightServiceAdd = (data: any) => http.post(`v1/service-adds`, data);
export const listFreightServiceAdd = (params?: FreightServiceAddParams) => http.get(`v1/service-adds`, { params });
export const singleFreightServiceAdd = (id: string) => http.get(`v1/service-adds/${id}`);
export const updateFreightServiceAdd = (id: string, data: any) => http.put(`v1/service-adds/${id}`, data);
export const deleteFreightServiceAdd = (id: string) => http.delete(`v1/service-adds/${id}`);